// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EwDifsyKUDejDS {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}
.nl01zzAUkGzPdq {
  margin-bottom: 116px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeleton": `EwDifsyKUDejDS`,
	"spinner": `nl01zzAUkGzPdq`
};
export default ___CSS_LOADER_EXPORT___;
